import React, { useState } from 'react'

import Actions from './Actions'
import Box from 'components_new/atoms/Box'
import Collapse from 'components_new/atoms/Collapse'

import SimpleSwipeableDrawer from 'components_new/molecules/SimpleSwipeableDrawer'

import DashboardPermissions from 'components_new/organisms/DashboardPermissions'

import InviteSection from './InviteSection'
import { useDashboardGroupActions } from 'redux/actions/DashboardGroups'
import { TDashboard } from 'types/GlobalDashboard'
import { TDashboardGroup } from 'types/GlobalDashboardGroup'

interface MobileProps {
  dashboard: TDashboard
  dashboardGroup: TDashboardGroup
  onClose: () => void
  onOpen: () => void
  open: boolean
  title: string
}

const Mobile = (props: MobileProps) => {
  const { dashboard, dashboardGroup, onClose, onOpen, open, title } = props

  const {
    tryInviteToDashboard,
    tryRevokeFromDashboard,
    tryUpdateDashboardGroup
  } = useDashboardGroupActions()

  const [tab, setTab] = useState<'default' | 'embed' | 'email'>('default')

  const isPublic = dashboard.share_settings.is_public
  const publicLink = dashboard.share_settings.public_link

  return (
    <>
      <SimpleSwipeableDrawer
        actions={
          tab === 'default' ? (
            <Box
              sx={{
                display: 'flex',
                gap: 1,
                flexWrap: 'wrap'
              }}
            >
              <Actions
                showActions={true}
                isPublic={isPublic}
                onClose={onClose}
                publicLink={publicLink}
                setTab={(value) => setTab(value)}
                tab={tab}
              />
            </Box>
          ) : undefined
        }
        onBack={tab === 'email' ? () => setTab('default') : undefined}
        onClose={onClose}
        onOpen={onOpen}
        open={open}
        title={title}
      >
        <Collapse in={tab === 'default'}>
          <DashboardPermissions
            dashboardGroup={dashboardGroup}
            onInvite={(permission) =>
              tryInviteToDashboard(dashboardGroup.id, permission)
            }
            revokeAccess={(body) =>
              tryRevokeFromDashboard(dashboardGroup.id, body)
            }
            setWhoCanView={(whoCanView) =>
              tryUpdateDashboardGroup(dashboardGroup.id, {
                permission_type: whoCanView
              })
            }
          />
        </Collapse>
        <Collapse in={tab === 'email'}>
          <InviteSection
            id={dashboardGroup.id}
            onGoBack={() => setTab('default')}
          />
        </Collapse>
      </SimpleSwipeableDrawer>
    </>
  )
}

export default Mobile
